// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { put, call, takeEvery } from 'redux-saga/effects';
import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

import AttachmentsDal from './../../../dal/AttachmentsDal';
import {
    UPLOAD_SAFETY_ATTACHMENTS,
    uploadSafetyAttachmentsSuccess,
} from './../../../store/attachments';

export function* postAttachments(request: any): IterableIterator<any> {
    try {
        yield put(
            actionStatusStarted({ actionName: UPLOAD_SAFETY_ATTACHMENTS })
        );
        const response = yield call(AttachmentsDal.uploadFiles, request);
        yield put(uploadSafetyAttachmentsSuccess(response));
        yield put(
            actionStatusSuccess({ actionName: UPLOAD_SAFETY_ATTACHMENTS })
        );
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: UPLOAD_SAFETY_ATTACHMENTS,
                error: e,
            })
        );
    }
}

export default [takeEvery(`${UPLOAD_SAFETY_ATTACHMENTS}`, postAttachments)];
